import { Route, Routes } from "react-router"
import { Templates } from "./Templates"
import ScenarioEdit from "./Scenario.edit"
import Scenarios from "."

function ScenariosRouter() {
  return (
    <Routes>
      <Route path="templates" element={<Templates />} />
      <Route path=":id" element={<ScenarioEdit />} />
      <Route index path="/*" element={<Scenarios />} />
    </Routes>
  )
}

export default ScenariosRouter
